import React from "react";
import clsx from "clsx";

const VARIANTS = {
  primary: "btn-primary",
  secondary: "btn-secondary",
  outline: "btn-outline",
  danger: "btn-danger",
  ghost: "btn-ghost",
};

const Button = ({ variant = "primary", className, type = "button", children, ...props }) => (
  <button type={type} className={clsx("btn", VARIANTS[variant], className)} {...props}>
    {children}
  </button>
);

export default Button;
